import axios from 'axios'
import store from '@/store'

async function beforeEnter(to, from, next) {
    const { registrationToken } = to.params

    // If user is aleady logged in, log them out
    if (store.getters.auth) {
        store.dispatch('forceLogout')
        window.location.href = `/login/${registrationToken}`
        return
    }

    // Get registration token from backend, if it's valid
    try {
        const response = await axios.get(`/registration-tokens/${registrationToken}`)
        to.params.registrationToken = response.data
        next()
    } catch (error) {
        next('/404')
    }
}

export default beforeEnter
